module.exports = __webpack_public_path__ + "assets/img/abb75436bf7bcccc6a2a5eb015a3e312.svg";